import axios from "axios";

export function getAllUserPayments() {
  return axios.get(process.env.VUE_APP_API_URL + "UserStudentPayment/GetAll");
}

export function returnOrder(data) {
  return axios.post(process.env.VUE_APP_API_URL + "UserStudentPayment/Return", data);
}

export function getAllOrders(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "UserStudentPayment/GetAllOrders", config);
}

export function returnPre(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "UserStudentPayment/ReturnPre", data, config);
}
export function returnPreConfirm(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "UserStudentPayment/ReturnPreConfirm", data, config);
}
export function orderBankReturn(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "UserStudentPayment/BankReturn", data, config);
}
export function returnOrderConfirm(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "UserStudentPayment/ReturnOrderConfirm", data, config);
}

export function preInvalidRefund(data) {
  return axios.post(process.env.VUE_APP_API_URL + "UserStudentPayment/PreInvalidRefund", data); //Eğitim Dairesi
}
export function preInvalidRefundConfirmed(data) {
  return axios.post(process.env.VUE_APP_API_URL + "UserStudentPayment/PreInvalidRefundConfirmed", data); //MuhasebeUser
}
export function invalidRefundConfirmed(data) {
  return axios.post(process.env.VUE_APP_API_URL + "UserStudentPayment/InvalidRefundConfirmed", data); //MuhasebeAdmin
}
